import { render, staticRenderFns } from "./fpcListnew.vue?vue&type=template&id=3180aaee&scoped=true&"
import script from "./fpcListnew.vue?vue&type=script&lang=js&"
export * from "./fpcListnew.vue?vue&type=script&lang=js&"
import style0 from "./fpcListnew.vue?vue&type=style&index=0&id=3180aaee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3180aaee",
  null
  
)

export default component.exports